import React from 'react'
import { Box, Container, Link, Typography } from '@mui/material'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  const footerLinks = [
    { label: 'Help', href: '#' },
    { label: 'FAQs', href: '#' },
    { label: 'Contact Us', href: '#' },
    { label: 'Privacy Policy', href: '#' },
    { label: 'Terms and Conditions', href: '#' },
  ]

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'primary.main',
        color: 'white',
        py: 3,
        mt: 'auto'
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            borderBottom: '1px solid rgba(255, 255, 255, 0.3)',
            pb: 2,
            mb: 2
          }}
        >
          <Typography 
            variant="h6" 
            sx={{ 
              fontWeight: 500,
              mb: 2,
              fontSize: '18px'
            }}
          >
            Broadridge Financial Solutions
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 3
            }}
          >
            {footerLinks.map((link, index) => (
              <Link
                key={index}
                href={link.href}
                sx={{
                  color: 'white',
                  textDecoration: 'none',
                  fontSize: '14px',
                  '&:hover': {
                    textDecoration: 'underline',
                  }
                }}
              >
                {link.label}
              </Link>
            ))}
          </Box>
        </Box>
        <Typography
          variant="body2"
          sx={{
            fontSize: '12px',
            color: 'rgba(255, 255, 255, 0.8)'
          }}
        >
          © 2006 - {currentYear} Broadridge Financial Solutions, Inc. The Broadridge Logo is a registered trademark of Broadridge North America, Inc.
        </Typography>
      </Container>
    </Box>
  )
}

export default Footer
